// klaviyo-integration.js
(function() {
    var klaviyoCompanyId = 'LfEwp6';
    var _learnq = window._learnq || [];
    var klAjax = true;
  
    // Load Klaviyo script
    var klaviyoScript = document.createElement('script');
    klaviyoScript.async = true;
    klaviyoScript.src = `//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoCompanyId}`;
    document.head.appendChild(klaviyoScript);
  
    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`)
        .then(res => res.clone().json().then(data => {
          var cart = {
            total_price: data.total_price/100,
            $value: data.total_price/100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price/100,
            items: data.items
          };
          if (typeof item !== 'undefined') {
            cart = Object.assign(cart, item);
          }
          if (klAjax) {
            _learnq.push(['track', 'Added to Cart', cart]);
            console.log('Klaviyo: Added to Cart event pushed', cart);
            klAjax = false;
          }
        }));
    }
  
    // Intercept fetch requests for add to cart
    (function(ns, fetch) {
      ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
          if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
            addedToCart();
          }
        });
        return response;
      };
    }(window, window.fetch));
  
    // Add event listeners to ATC buttons
    window.addEventListener('load', function() {
      var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
      for (var i = 0; i < atcButtons.length; i++) {
        atcButtons[i].addEventListener("click", function() {
          if (klAjax) {
            _learnq.push(['track', 'Added to Cart', item]);
            console.log('Klaviyo: Added to Cart event pushed (button click)', item);
            klAjax = false;
          }
        });
      }
    });
  
    // Function to track "Viewed Product" event
    window.trackViewedProduct = function(productData) {
      _learnq.push(['track', 'Viewed Product', productData]);
      console.log('Klaviyo: Viewed Product event pushed', productData);
    };
  })();